module.exports = __webpack_public_path__ + "img/border-top-left.ccd6a445.svg";